<script>
    import { mixins, HorizontalBar } from 'vue-chartjs'
    const { reactiveProp } = mixins

    export default {
        mixins: [reactiveProp, HorizontalBar],
        props: ['options'],
        mounted () {
            // this.chartData is created in the mixin.            
            this.renderChart(this.chartData, this.options)
        }
    }
</script>